<template>
  <div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('homework.actionForm') }}</legend>
                  <action-form-component v-model="model" :validate="errors">
                    <template v-slot:button-action>
                      <ts-button
                        class="mr-2"
                        @click.prevent="$router.push({ name: 'homework' })"
                        >{{ $t('cancel') }}</ts-button
                      >
                      <ts-button
                        color="primary"
                        :waiting="waiting"
                        @click.prevent="onUpdate"
                        >{{ $t('update') }}</ts-button
                      >
                    </template>
                  </action-form-component>
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('homework.attachmentFile') }}</legend>
                  <homework-attach-file v-model="model" />
                  <br />
                  <training-tool-attachFile v-model="model" />
                </fieldset>
              </form>
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import ActionFormComponent from './component/action-form'
import HomeworkAttachFile from './component/homework-attach-file'
import TrainingToolAttachFile from './component/training-tool-attach-file'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'staffHomewrokEdit',
  components: {
    ActionFormComponent,
    HomeworkAttachFile,
    TrainingToolAttachFile
  },
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      loading: false,
      model: {
        homework_date: moment(),
        class_id: '',
        teacher_id: '',
        subject_id: '',
        remarks: '',
        submission_end_date: moment().add(7, 'Day'),
        reference_url: [],
        attach_file_list: []
      }
    }
  },
  created() {},
  computed: {},
  methods: {
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('eschool/staffHomework/update', {
          id: this.$route.params.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'homework' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
